import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-type",
  "use": "icon-type-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-type\" id=\"icon-type\"><polyline points=\"4 7 4 4 20 4 20 7\" /><line x1=\"9\" y1=\"20\" x2=\"15\" y2=\"20\" /><line x1=\"12\" y1=\"4\" x2=\"12\" y2=\"20\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol